import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class UniversityFaqService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    getByAdmin(universityId): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.UNIVERSITY_FAQ(universityId));
    }

    createByAdmin(universityId, data): Observable<any> {
        return this.postRequest(AppUrl.UNIVERSITY_FAQ(universityId), data);
    }

    deleteByAdmin(universityId, id): Observable<any> {
        return this.deleteRequest(AppUrl.UNIVERSITY_FAQ_DELETE(universityId, id));
    }
}
